import React from 'react';
import SocialNetworks from './SocialNetworks';
import pgaSocialnetworks from './pgaSocialnetworks';
export default (function () {
  return React.createElement(SocialNetworks, {
    networks: pgaSocialnetworks
  });
});